export default __webpack_public_path__ + "static/media/aws-cloudwatch.fa9907a5.svg";